const CAPTURE_SCORE_THRESHOLD = process.env.CAPTURE_SCORE_THRESHOLD || 80

import { FC, useCallback, useMemo } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"

export interface VitalsProps {
   bpm?: number
   bpmStabilityScore?: number
   rpm?: number
   rpmStabilityScore?: number
   typefaceColor: IconColor
   testId?: string
}

const Vitals: FC<VitalsProps> = ({
   bpm,
   bpmStabilityScore = 0,
   rpm,
   rpmStabilityScore = 0,
   typefaceColor,
   testId,
}) => {
   const { bpmStable, rpmStable } = useMemo(() => {
      return {
         bpmStable: bpmStabilityScore > Number(CAPTURE_SCORE_THRESHOLD),
         rpmStable: rpmStabilityScore > Number(CAPTURE_SCORE_THRESHOLD),
      }
   }, [bpmStabilityScore, rpmStabilityScore])

   const getVital = useCallback(
      (
         value: number | undefined,
         iconName: IconProps["name"],
         stability: boolean
      ) => {
         return value ? (
            <span className="cell-card__vital">
               <span className="cell-card__vital-value">
                  {stability ? value : "-"}
               </span>
               <Icon
                  size="12"
                  color={typefaceColor}
                  name={iconName}
               />
            </span>
         ) : null
      },
      [typefaceColor]
   )

   return (
      <span
         className="cell-card__vitals"
         data-testid={testId}
      >
         {getVital(bpm, "heartRate", bpmStable)}
         {getVital(rpm, "respiratoryRate", rpmStable)}
      </span>
   )
}

export default Vitals
